import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import {
  NoResultsContainer,
  NoResultsIcon,
  NoResultsIconContainer,
  NoResultsText
} from './NoResults.styles'

export const NoResults = ({
  text,
  className,
  children,
  margin,
  padding,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <NoResultsContainer
      className={classnames('b-no-results', className)}
      data-mu-test={dataAttributeTest}
      $margin={margin}
      $padding={padding}
    >
      <NoResultsIconContainer>
        <NoResultsIcon />
      </NoResultsIconContainer>
      <NoResultsText>{children !== undefined ? children : text}</NoResultsText>
    </NoResultsContainer>
  )
}

NoResults.defaultProps = {
  margin: '20px 0 0 0',
  padding: '15px'
}

NoResults.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  margin: PropTypes.string,
  padding: PropTypes.string,
  'data-mu-test': PropTypes.string
}
